import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "../pages/HomePage";

const InvitationBuilderPage = lazy(
  () => import("../pages/InvitationBuilder/InvitationBuilderPage")
);
const EventTypesPage = lazy(
  () => import("../pages/EventTypes/EventTypesPage")
);
const TemplatesPage = lazy(
  () => import("../pages/Templates/TemplatesPage")
);

const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route
          path="/invitation-builder"
          element={
            <Suspense fallback={<div style={{ padding: 40, textAlign: "center" }}>טוען...</div>}>
              <InvitationBuilderPage />
            </Suspense>
          }
        />
        <Route
          path="/event-types"
          element={
            <Suspense fallback={<div style={{ padding: 40, textAlign: "center" }}>טוען...</div>}>
              <EventTypesPage />
            </Suspense>
          }
        />
        <Route
          path="/templates"
          element={
            <Suspense fallback={<div style={{ padding: 40, textAlign: "center" }}>טוען...</div>}>
              <TemplatesPage />
            </Suspense>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export { AppRouter };
